<!-- eslint-disable no-extra-parens -->
<template>
  <div class="patient-info-wrap">
    <div class="patient-info bg-white">
      <div class="patient">
        <div class="cell-label">
          <div class="star">*</div>就诊人：
        </div>
        <div class="cell-value" @click="toPatientList">
          <div v-if="patientItem.id">{{ patientItem.name || '' }}&nbsp;&nbsp;{{ formatSex || '' }}&nbsp;&nbsp;{{
            patientItem.age || '' }}</div>
          <div v-else class="placeholder">请选择</div>
          <SvgIcon icon-class="arrow_right" v-if="patientData.channel === 'YJK_SR'" class="arrow" />
        </div>
      </div>
      <div class="patient female-patient"
        v-if="patientItem.sex == 2 && patientItem.ageValue >= 14 && patientItem.ageValue <= 60">
        <e-select v-model="pregnantSituation" :count="1" @on-other="hh" title="您好，为了女性患者用药安全，请选择以下情况"
          :selectList="pregnantList"></e-select>
      </div>
      <div class="patient">
        <div class="cell-label">
          <div class="star">*</div>初诊医院：
        </div>
        <div class="cell-value" @click="chooseHospital = true">
          <div v-if="hospitalItem.hospitalName">{{ hospitalItem.hospitalName }}</div>
          <div v-else class="placeholder">请选择</div>
          <SvgIcon icon-class="arrow_right" class="arrow" />
        </div>
      </div>
    </div>
    <div class="ill-info bg-white">
      <div class="cell-label">
        <div class="star">*</div>就诊人既往病情信息：
      </div>
      <!-- 区别中药 -->
      <div v-if="patientData.medicineType === 2">
        <div class="cell-label">1、请描述病情：</div>
        <div class="textarea-box other">
          <textarea class="textarea" v-model="illnessDesc_zy" placeholder="为了医师更好的帮您解决问题，请尽可能详细的描述病情"
            maxlength="150"></textarea>
          <div class="count" v-if="illnessDesc_zy">{{ illnessDesc_zy.length }}/150</div>
          <div class="count" v-else>0/150</div>
        </div>
      </div>
      <e-select v-if="patientData.medicineType === 1" v-model="illnessDesc" :changeAble="changeIll"
        :other="illnessDescOther" :title="illnessDescTitle" :count="5" :selectList="illnessDescList"
        @on-other="(val) => { illnessDescOther = val }"></e-select>
      <e-select v-model="isStable" :count="1" title="2、病情是否稳定？" :selectList="isStableList"
        @on-change="changeStable"></e-select>
      <e-select v-model="pastHistory" :other="pastHistoryOther" title="3、是否有既往史？(可多选)" :selectList="pastHistoryList"
        @on-other="(val) => { pastHistoryOther = val }"></e-select>
      <e-select v-model="taboo" :other="tabooOther" :count="1" title="4、是否有用药禁忌？" :selectList="tabooList"
        @on-other="(val) => { tabooOther = val }"></e-select>
      <e-select v-model="allergicHistory" :other="allergicHistoryOther" title="5、是否有用药物过敏？(可多选)"
        :selectList="allergicHistoryList" @on-other="(val) => { allergicHistoryOther = val }"></e-select>
      <e-select v-model="liverFunctionNormal" title="6、肝功能是否正常？" :count="1" :selectList="isLiverNormalList"></e-select>
      <e-select v-model="kidneyFunctionNormal" title="7、肾功能是否正常？" :count="1" :selectList="isRenalNormalList"></e-select>
    </div>
    <div class="report-info">
      <div class="report-info-title">请上传<span class="lighthight">检查报告/患处照片/过往病历</span>（最多可上传9张）：</div>
      <Uploader :count='9' :uploadImgList="uploadImgList" @uploaderFn="uploaderFn" />
    </div>
    <div class="agreement-info bg-white">
      <div class="agreement-detail" @click="isChecked = !isChecked" v-if="agreementList.length > 0">
        <img class="radio-img" :src="isChecked ? radioActivePath : radioDefaultPath">
        <div class="agreement-list">
          <span>我已仔细阅读并同意</span>
          <span v-for="ag in agreementList" :key="ag" class="agreement-item" @click.stop="toReport(ag)">
            《{{ ag.protocolName }}》
          </span>
        </div>
      </div>
      <button @click="submit(0)">立即问诊</button>
    </div>
    <van-popup :show="chooseHospital" round position="bottom">
      <div class="hospital-list ">
        <div @click="selectOptions($event, index)" class="item" v-for="(item, index) in hospitalList" :key="index">
          {{ item.hospitalName }}</div>
      </div>
    </van-popup>
    <van-dialog :show="show" theme='round-button' :showCancelButton='true' confirmButtonText='继续问诊'
      cancelButtonText='重新问诊' @confirm="confirm" @cancel="submit(1)">
      <div class="dialog-tip">您正在咨询【{{ doctorData.departmentName }}】的【{{ doctorData.doctorName }}】医生，继续问诊还是<span
          class="tip-text">结束问诊</span>咨询其他医生?</div>
    </van-dialog>
  </div>
</template>
<script>
import {
  getPatientIllness,
  createConsultOrder,
  getHospitals,
  getConfigInfo
} from '@/api/work/patient';
import {
  formatSex,
  formatChannel
} from '@/common/js/computed';
import radioDefaultPath from '@/assets/radio_default.png';
import radioActivePath from '@/assets/radio_active.png';
import Uploader from '@/components/uploader.vue';
import bridgeService from '@/lib/dsbridgeService';
import ESelect from './components/ESelect.vue';

export default {
  name: 'patientInfo',
  components: {
    Uploader,
    ESelect,
  },
  data() {
    return {
      show: false,
      isChecked: true,
      radioDefaultPath,
      radioActivePath,
      chooseHospital: false,
      canChoosePatient: false,
      uploadImgList: [],
      changeIll: true,
      pregnantList: [{
        label: '无特殊',
        value: 4,
      }, {
        label: '备孕期',
        value: 3,
      }, {
        label: '妊娠期',
        value: 1,
      }, {
        label: '哺乳期',
        value: 2,
      }],
      pregnantSituation: [],
      illnessDescList: [],
      illnessDesc: [],
      illnessDescOther: '',
      illnessDescTitle: '1、请问患者是否已确认以下病情：(最多选5个)',
      illnessDesc_zy: '',
      isStableList: [{
        label: '稳定',
        value: 1,
      }, {
        label: '不稳定',
        value: 0,
      }],
      isStable: [1],
      pastHistoryList: [{ label: '无', value: '无', },
        { label: '高血压病', value: '高血压病', },
        { label: '糖尿病', value: '糖尿病', },
        { label: '痛风', value: '痛风', },
        { label: '泌尿系结石', value: '泌尿系结石', },
        { label: '心脏病', value: '心脏病', },
        { label: '哮喘', value: '哮喘', }],
      pastHistory: ['无'],
      pastHistoryOther: '',
      taboo: ['无'],
      tabooList: [{ label: '无', value: '无', }],
      tabooOther: '',
      allergicHistory: ['无'],
      allergicHistoryList: [{ label: '无', value: '无', },
        { label: '青霉烷类', value: '青霉烷类', },
        { label: '头抱菌素类', value: '头抱菌素类', },
        { label: '大环内酯类', value: '大环内酯类', },
        { label: '喹诺酮类', value: '喹诺酮类', },
        { label: '牛奶', value: '牛奶', }],
      allergicHistoryOther: '',
      isLiverNormalList: [{
        label: '正常',
        value: 1,
      }, {
        label: '不正常',
        value: 0,
      }],
      liverFunctionNormal: [1],
      isRenalNormalList: [{
        label: '正常',
        value: 1,
      }, {
        label: '不正常',
        value: 0,
      }],
      kidneyFunctionNormal: [1],
      hospitalList: [{
        hospitalName: '其他',
        id: -1,
      }],
      agreementList: [],
      doctorData: {},
      patientData: {},
    };
  },
  computed: {
    hospitalItem() {
      return this.$store.state.hospitalItem;
    },
    formatSex() {
      return formatSex(this.patientItem?.sex);
    },
    boardId() {
      return this.$route.query.whiteBoardId;
    },
    patientItem() {
      return this.$store.state.patientItem;
    },
  },
  methods: {
    changeStable(val) {
      if (val[0] === 0) {
        this.$dialog.alert({
          title: '问诊提醒！',
          message: '您好，很抱歉，根据国家政策规定，病情不稳定的复诊患者建议尽快到当地医院看诊，待病情稳定后可再到平台上进行问诊开药。',
          theme: 'round-button',
          showCancelButton: true,
          confirmButtonText: '继续问诊',
          cancelButtonText: '放弃问诊',
        }).then(() => {
          this.isStable[0] = 1;
        }).catch(() => {
          // 返回订单详情页面
          if (this.$isInWxMP) {
            this.$wx.miniProgram.navigateBack();
          } else {
            bridgeService.popViewCotroller();
          }
        });
      }
    },
    toPatientList() {
      if (this.patientData.channel !== 'YJK_SR') return;
      this.$router.push({
        path: '/patient-list',
        query: {
          from: 'work',
        },
      });
    },
    // 文件上传回调
    uploaderFn(fileList) {
      this.uploadImgList = fileList || [];
    },
    checkEmpty() {
      // eslint-disable-next-line no-extra-parens
      if (!(this.patientItem.id) || !(this.hospitalItem.id)) {
        return false;
      }
      if (this.patientItem.sex === 2 && this.patientItem.ageValue >= 14 && this.patientItem.ageValue <= 60 && this.pregnantSituation.length < 1) {
        return false;
      }
      // eslint-disable-next-line no-extra-parens
      if ((this.illnessDesc.length < 1 && this.illnessDescOther.length < 1 && this.illnessDesc_zy.length < 1)
          || this.isStable.length < 1
          // eslint-disable-next-line no-extra-parens
          || (this.pastHistory.length < 1 && this.pastHistoryOther.length < 1)
          // eslint-disable-next-line no-extra-parens
          || (this.taboo.length < 1 && this.tabooOther.length < 1)
          // eslint-disable-next-line no-extra-parens
          || (this.allergicHistory.length < 1 && this.allergicHistoryOther.length < 1)
        || this.liverFunctionNormal.length < 1
        || this.kidneyFunctionNormal.length < 1) {
        return false;
      }
      return true;
    },
    confirm() {
      this.show = false;
      const { consultId, } = this.doctorData;
      if (this.$isInWxMP) {
        this.$wx.miniProgram.navigateTo({
          url: `/pages/buyDrugSelf/pages/im/im?orderId=${consultId}`,
        });
      } else {
        bridgeService.pushViewCotroller(`dsl://chat_new/toChat?orderNumber=${consultId}`);
      }
    },
    async submit(closeOldConsultOrder = 0) {
      console.error('illnessDescOther', this.illnessDescOther);
      if (!this.isChecked) {
        this.$toast('请先阅读并同意协议');
        return;
      }
      if (!this.checkEmpty()) {
        this.$toast('请完成必填信息的填写');
        return;
      }
      const newIllnessDesc = [...this.illnessDesc];
      const newPastHistoryOther = [...this.pastHistory];
      if (this.illnessDescOther) {
        newIllnessDesc.push(this.illnessDescOther);
      }
      if (this.pastHistoryOther) {
        newPastHistoryOther.push(this.pastHistoryOther);
      }
      const taboo = this.taboo.length > 0 ? this.taboo[0] : this.tabooOther;
      const allergicHistory = this.allergicHistory.length > 0 ? this.allergicHistory[0] : this.allergicHistoryOther;
      const params = {
        wbId: this.boardId,
        patientId: this.patientItem.id,
        pregnantSituation: this.pregnantSituation[0],
        visitHospital: this.hospitalItem.hospitalName,
        illnessDesc: this.patientData.medicineType === 2 ? this.illnessDesc_zy.split('；') : newIllnessDesc,
        isStable: this.isStable[0],
        pastHistory: newPastHistoryOther,
        taboo,
        allergicHistory,
        liverFunctionNormal: this.liverFunctionNormal[0],
        kidneyFunctionNormal: this.kidneyFunctionNormal[0],
        consultFiles: this.uploadImgList,
        isExistPastHistory: newPastHistoryOther.length > 0 ? 1 : 0,
        isExistDrugBand: taboo === '无' ? 0 : 1,
        isExistDrugAllergy: allergicHistory === '无' ? 0 : 1,
        isRenalNormal: this.liverFunctionNormal[0],
        closeOldConsultOrder,
      };
      console.error('createConsultOrder', params);
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '加载中...',
      });
      const res = await createConsultOrder(params);
      this.$toast.clear();
      if (res.success) {
        this.doctorData = res.data;
        if (res.data.isUseBoardId === 0) {
          // 白板id没被使用
          if (res.data.isExistConsultOrder === 1) {
            // 存在问诊单
            this.show = true;
          } else {
            this.confirm();
          }
        } else {
          // 白板id已被使用
          // eslint-disable-next-line no-lonely-if
          this.show = false;
          if (res.data.isExistConsultOrder === 1) {
            // 存在问诊单
            this.confirm();
          } else {
            this.$toast('当前已发起问诊，不可重复发起问诊。');
          }
        }
      } else {
        this.show = false;
        if (res.code === 10011) {
          this.$router.push({ path: '/nodoctor', });
        }
      }
    },
    toReport(item) {
      this.$router.push({
        path: '/agrement-detail',
        query: {
          file: `${item.file}`,
        },
      });
    },
    selectOptions(e, index) {
      console.error(this.hospitalList);
      const item = this.hospitalList[index];
      console.error(item);
      this.chooseHospital = false;

      if (item.id === -1) {
        // 其他
        this.$router.push({
          path: '/hospital-search',
          query: {
            name: this.patientData.shopCity,
          },
        });
      } else {
        this.$store.commit('hospitalItem', { ...item, });
      }
    },
    async init() {
      if (!this.boardId) return;
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '加载中...',
      });
      const { data, } = await getPatientIllness(this.boardId);
      if (data.channel !== 'YJK_SR') {
        const patientData = {
          age: `${data?.age?.age}${data?.age?.ageUnit}`,
          ageValue: data?.age?.age,
          id: data.patientId,
          name: data.patientName,
          phone: data.phone || '',
          sex: data.patientGender,
        };
        console.error('patientData', patientData);
        this.patientData = { ...data, ...patientData, };
        this.$store.commit('patientItem', { ...patientData, });
        this.$store.commit('changePatient', true);
      } else {
        this.patientData = data;
      }
      // 中药
      if (data.medicineType === 2) {
        this.illnessDesc_zy = data.illnessDesc.join('；') || '';
      } else {
        // illnessType病情描述类型 代码取值：0-没有带入 1-统编功能主治 2-业务带入
        this.illnessDesc = data.illnessType === 2 ? data.illnessDesc || [] : [];
        if (data.illnessDesc.length > 0) {
          this.illnessDescList = data.illnessDesc.map((i) => {
            const obj = {};
            obj.label = i;
            obj.value = i;
            return obj;
          });
          if (data.illnessType === 2 && data.channel === 'YJK_CE') {
            this.illnessDescTitle = '1、患者已确诊以下疾病';
            this.illnessDescOther = undefined;
            this.changeIll = false;
          } else {
            this.illnessDescOther = '';
            this.changeIll = true;
            this.illnessDesc = [];
          }
        } else {
          // 没有诊断带入
          this.illnessDescOther = '';
        }
      }
      if (data.pastHistory.length > 0) {
        this.pastHistoryList = data.pastHistory.map((i) => {
          const obj = {};
          obj.label = i;
          obj.value = i;
          return obj;
        });
        this.pastHistory = data.pastHistory;
      } else {
        this.pastHistory = ['无'];
      }
      this.pastHistoryOther = data.pastHistory.length > 0 ? undefined : '';
      this.uploadImgList = data.consultFiles;
      if (data.allergicHistory.length > 0) {
        this.allergicHistory = data.allergicHistory.split(';').filter((i) => i !== '');
        this.allergicHistoryList = this.allergicHistory.map((i) => {
          const obj = {};
          obj.label = i;
          obj.value = i;
          return obj;
        });
      }
      const { data: { records, }, } = await getHospitals({
        hospitalName: data.shopCity,
      });
      const list = records.map((i) => {
        const obj = {
          hospitalName: i.hospitalName,
          id: i.hospitalId,
        };
        return obj;
      });
      const oth = {
        hospitalName: '其他',
        id: -1,
      };
      this.hospitalList = [...list, oth];
      // 先去掉协议
      const channel = formatChannel(data.channel);
      const agreementList = await getConfigInfo({
        user_code: data.channel,
        clientId: data.channel,
        appName: channel.channelStr,
        type: channel.type,
        code: 'Risk_Notification',
      });
      this.agreementList = agreementList.data || [];
      this.isChecked = this.agreementList.length < 1;
      this.$toast.clear();
    },
  },
  created() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.patient-info-wrap {
  position: relative;
}

.bg-white {
  background: #fff;
  border-radius: 16px;
  padding: 20px 15px;
  box-sizing: border-box;
  margin-bottom: 12px;
}

.ill-info {
  padding: 20px 15px 0 15px;
}

.patient-info {
  border-radius: 0 0 16px 16px;

  .patient {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .female-patient {
    margin-bottom: 15px;
  }
}

.cell-label {
  @include font(16px, 24px, #666);
  @include flex(center);

  margin-bottom: 10px;

  .star {
    @include font(16px, 24px, #FF0000);
  }
}

.cell-value {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 12px 15px;
  box-sizing: border-box;

  @include font(16px, 24px, $primary-text-color);
  @include flex(center, space-between);

  .placeholder {
    @include font(16px, 24px, #9A9FA8);
  }
}

.report-info {
  padding-top: 20px;
  background: #fff;
  box-sizing: border-box;
  border-radius: 16px;
  margin-bottom: 130px;
  margin-bottom: calc(130px + constant(safe-area-inset-bottom));
  margin-bottom: calc(130px + env(safe-area-inset-bottom));

  .report-info-title {
    @include font(16px, 24px, #666);

    padding: 0 15px;
    box-sizing: border-box;
    margin-bottom: 7px;

    .lighthight {
      @include font(16px, 24px, #01BB6E);
    }
  }
}

.agreement-info {
  // position: absolute;
  // bottom: 0;
  margin-bottom: 0;
  border-radius: 0;

  @include fixed-bottom(10px, 15px, 10px, 15px);

  .agreement-detail {
    display: flex;

    .radio-img {
      width: 15px;
      height: 15px;
      margin-right: 10px;
    }

    .agreement-list {
      display: inline-block;

      @include font(12px, 17px, #666);

      .agreement-item {
        @include font(12px, 17px, #0275FF);
      }
    }
  }

  button {
    width: 100%;
    background: linear-gradient(151deg, #42e9a4 0%, #01bb6e 100%);
    border-radius: 25px;
    padding: 13px;

    @include font(17px, 24px, #fff, center);

    margin-top: 10px;
  }
}

.hospital-list {
  padding-top: 12px;
  padding-bottom: calc(12px + constant(safe-area-inset-bottom));
  padding-bottom: calc(12px + env(safe-area-inset-bottom));

  .item {
    @include font(16px, 24px, $primary-text-color, center);

    padding: 12px 0;
  }
}

.dialog-tip {
  margin: 0 20px;

  @include font(15px, 21px, #666);

  .tip-text {
    color: #01bb6e;
  }
}

.textarea-box {
  display: block;
  width: 100%;
  height: 150px;
  background-color: $background-color-2;
  border-radius: $regular-border-radius;
  margin-bottom: 30px;

  .textarea {
    @include font(16px, 24px);

    width: 100%;
    height: 118px;
    padding: 12px 15px;
    box-sizing: border-box;
    resize: none;
  }

  .count {
    @include font(14px, 20px, $regular-text-color, right);

    padding: 0 15px;
  }

  &.other {
    height: 127px;

    .textarea {
      height: 95px;
    }
  }
}
</style>
